import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';

class Task extends React.Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.onSelect) {
      this.props.onSelect(this.props.task);
    }
  }

  render() {

    const task = Object.assign({}, this.props.task);
    const startTime = task.start.toDateLocal();
    const endTime = task.end.toDateLocal();

    const range = Math.abs(moment(endTime).diff(moment(startTime), 'days')) + 1;
    const start = range === 1 ? moment(startTime).format('DD MMM') : moment(startTime).format('DD MMM - hh:mm a');
    const end = range === 1 ? `${moment(startTime).format('hh:mm a')} - ${moment(endTime).format('hh:mm a')}` : moment(endTime).format('DD MMM - hh:mm a');

    const assigned = task.resourceName;

    return (
      <div onClick={this.handleClick}>
        <span>
          <strong>{task.title}</strong>
        </span><br />
        <span>{start}</span><br />
        <span>{end}</span><br />
        <span>{assigned}</span>
      </div>
    );
  }
}

class TaskList extends React.Component {

  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(selectedTask) {
    if (this.props.onSelect) {
      this.props.onSelect(selectedTask);
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.tasks.map((task, index) => (
          <Task
            key={index}
            task={task}
            onSelect={this.handleSelect} />
        ))}
      </Fragment>
    );
  }
}

TaskList.defaultProps = {
  tasks: []
}

TaskList.propTypes = {
  tasks: PropTypes.array
}

export default TaskList;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSchedule/TaskList.js